// Routes definition
const routes_api = {

    // Token
    token_obtain_pair: "/api/token/",
    token_refresh: "/api/token/refresh/",

    // Accounts
    accounts_login: "/api/accounts/login/",
    accounts_logout: "/api/accounts/logout/",
    accounts_getuser: "/api/accounts/getuser/",
    accounts_update: "/api/accounts/update/",
    accounts_userpreferences: "/api/accounts/user-preferences/",
    accounts_mcp_keys: "/api/accounts/mcp-keys/",
    accounts_mcp_scopes: "/api/accounts/mcp-scopes/",
    accounts_audit_log: "/api/accounts/audit-log/",

    // Invite Codes
    invite_validate: "/api/invite/validate/",
    invite_register: "/api/invite/register/",
    invite_check_username: "/api/invite/check-username/",

    // Health
    health_records: "/api/health/records/",
    health_records_deleteall: "/api/health/records/delete_all/",
    health_records_createmany: "/api/health/records/create_many/",
    health_professionals: "/api/health/professionals/",
    health_embedded_notepad_cluster: "/api/health/embedded-notepad-cluster/",

    // Travel
    travel_trips: "/api/travel/trips/",
    travel_trips_deleteall: "/api/travel/trips/delete_all/",
    travel_trips_createmany: "/api/travel/trips/create_many/",
    /** POST/DELETE multipart cover: `${travel_trips}${id}/cover/` */
    travel_trip_cover: (tripId) => `/api/travel/trips/${tripId}/cover/`,
    travel_places: "/api/travel/places/",
    travel_embedded_notepad_cluster: "/api/travel/embedded-notepad-cluster/",

    // Core
    core_frameworks: "/api/core/frameworks/",
    /** POST/DELETE multipart image: `${core_frameworks}${id}/image/` */
    core_framework_image: (frameworkId) => `/api/core/frameworks/${frameworkId}/image/`,
    core_cycles: "/api/core/cycles/",
    /** POST/DELETE multipart image: `${core_cycles}${id}/image/` */
    core_cycle_image: (cycleId) => `/api/core/cycles/${cycleId}/image/`,

    // Finance
    finance_setup: "/api/finance/setup/",
    finance_flows: "/api/finance/flows/",
    finance_flows_preliminary: "/api/finance/flows-preliminary/",
    finance_flows_preliminary_create_many: "/api/finance/flows-preliminary/create_many/",
    finance_flows_preliminary_delete_many: "/api/finance/flows-preliminary/delete_many/",
    finance_flows_getyears: "/api/finance/flows/get_years/",
    finance_flows_deleteall: "/api/finance/flows/delete_all/",
    finance_flows_createmany: "/api/finance/flows/create_many/",
    finance_flows_consolidated: "/api/finance/flows/consolidated/",
    finance_flows_categories: "/api/finance/flows-categories/",
    finance_flows_categories_hierarchical: "/api/finance/flows-categories/hierarchical/",
    finance_accounts: "/api/finance/accounts/",
    finance_accounts_history: "/api/finance/accounts-history/",
    finance_extras_pluggytoken: "/api/finance/extras/pluggy-token/",
    finance_extras_pluggycredentials: "/api/finance/extras/pluggy-credentials/",
    finance_extras_pluggyitems: "/api/finance/extras/pluggy-items/",
    finance_extras_pluggyaccounts: "/api/finance/extras/pluggy-accounts/",
    finance_extras_pluggytransactions: "/api/finance/extras/pluggy-transactions/",
    finance_profile: "/api/finance/profile/",
    finance_currencies: "/api/finance/currencies/",
    finance_currencies_available: "/api/finance/currencies/available/",
    finance_budget_plans: "/api/finance/budgets/plans/",
    finance_budget_plan_items: "/api/finance/budgets/plan-items/",
    finance_budget_board: "/api/finance/budget/board/",
    finance_asset_locations: "/api/finance/assets/locations/",
    finance_asset_locations_create_many: "/api/finance/assets/locations/create_many/",
    finance_asset_categories: "/api/finance/assets/categories/",
    finance_asset_categories_create_many: "/api/finance/assets/categories/create_many/",
    finance_asset_items: "/api/finance/assets/items/",
    finance_asset_items_create_many: "/api/finance/assets/items/create_many/",
    finance_asset_items_import_excel: "/api/finance/assets/items/import_excel/",
    finance_asset_items_export_excel: "/api/finance/assets/items/export_excel/",
    finance_asset_items_delete_all: "/api/finance/assets/items/delete_all/",
    finance_asset_operations: "/api/finance/assets/operations/",
    finance_asset_operations_create_many: "/api/finance/assets/operations/create_many/",
    finance_asset_returns: "/api/finance/assets/returns/",
    finance_asset_returns_create_many: "/api/finance/assets/returns/create_many/",
    finance_asset_snapshots: "/api/finance/assets/snapshots/",
    finance_asset_snapshots_save_with_items: "/api/finance/assets/snapshots/save-with-items/",
    finance_asset_snapshots_create_batch: "/api/finance/assets/snapshots/create_batch/",
    finance_asset_snapshot_items: "/api/finance/assets/snapshot-items/",
    finance_asset_snapshot_items_create_batch: "/api/finance/assets/snapshot-items/create_batch/",
    finance_asset_snapshot_items_delete_by_snapshot: "/api/finance/assets/snapshot-items/delete_by_snapshot/",
    finance_asset_snapshot_items_update_positions: "/api/finance/assets/snapshot-items/update_snapshot_positions/",
    finance_asset_snapshot_items_update_market_info: "/api/finance/assets/snapshot-items/update_snapshot_market_info/",
    finance_asset_snapshot_items_preview_market_info: "/api/finance/assets/snapshot-items/preview_market_info/",
    finance_asset_full: "/api/finance/assets/full/",
    finance_asset_config_custom_update: "/api/finance/assets/config-custom-update/",
    finance_asset_embedded_notepad_notes: "/api/finance/assets/embedded-notepad-notes/",
    finance_asset_year_report: "/api/finance/assets/year-report/",

    // Planner
    planner_todo: "/api/planner/todo/",
    planner_todo_reorder: "/api/planner/todo/reorder_todo/",
    planner_todo_items: "/api/planner/todoitems/",
    planner_calendars: "/api/planner/calendars/",
    planner_events: "/api/planner/events/",
    planner_projects: "/api/planner/projects/",
    planner_project_columns: "/api/planner/project-columns/",
    planner_project_cards: "/api/planner/project-cards/",

    planner_google_oauth_start: "/api/planner/google/oauth/start/",
    planner_google_status: "/api/planner/google/status/",
    planner_google_disconnect: "/api/planner/google/disconnect/",
    planner_google_remote_calendars: "/api/planner/google/remote-calendars/",
    planner_google_create_remote_calendar: "/api/planner/google/create-remote-calendar/",
    planner_google_sync_manual: "/api/planner/google/sync/manual/",

    // Notepad
    notepad_clusters: "/api/notepad/clusters/",
    notepad_notes: "/api/notepad/notes/",

    // Identity (True Identity / IDEM)
    identity_summary: "/api/identity/summary/",
    identity_state: "/api/identity/state/",
    identity_assistant_card: "/api/identity/assistant-card/",
    identity_settings: "/api/identity/settings/",
    identity_settings_avatar: "/api/identity/settings/avatar/",
    identity_files: "/api/identity/files/",
    identity_files_batch: "/api/identity/files/batch/",
    identity_file: "/api/identity/file/",
    identity_search: "/api/identity/search/",
  };
  
  export default routes_api;
